import script from "./SupervisionBanner.vue?vue&type=script&lang=ts&setup=true"
export * from "./SupervisionBanner.vue?vue&type=script&lang=ts&setup=true"

import "./SupervisionBanner.vue?vue&type=style&index=0&id=60b5beec&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-60b5beec"]])

export default __exports__